export default __webpack_public_path__ + "static/media/wifi.bade4d75.svg";